import { render, staticRenderFns } from "./ScholarshipLevelMinimum.vue?vue&type=template&id=b6a21972&"
import script from "./ScholarshipLevelMinimum.vue?vue&type=script&lang=js&"
export * from "./ScholarshipLevelMinimum.vue?vue&type=script&lang=js&"
import style0 from "./ScholarshipLevelMinimum.vue?vue&type=style&index=0&id=b6a21972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports